import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "#/hooks/query-keys";
import { fetchAppSettings } from "#/lib/api/app-settings";

/**
 * Loads public policy values (withdraw minimum, referral minimum, default
 * revenue share, payout chain) from the backend. Server config is the
 * source of truth — the frontend should never hardcode these.
 *
 * Cached aggressively (1h staleTime) since these values rarely change and
 * a slightly stale gate is cheap to live with: the server re-validates on
 * every withdraw / create-code request, so the worst case is one round
 * trip back from the server saying "actually the new floor is X."
 */
export function useAppSettings() {
	return useQuery({
		queryKey: queryKeys.app.settings(),
		queryFn: () => fetchAppSettings(),
		staleTime: 60 * 60 * 1000,
		gcTime: 24 * 60 * 60 * 1000,
	});
}
